var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHndLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    "data-name": "Layer 3",
    viewBox: "0 0 1050 1050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99604 0 0 1.0003 1.9814 -.1455)",
    strokeWidth: 1.0018
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1014.6 524.99a489.47 487.36 0 0 1-489.3 487.36 489.47 487.36 0 0 1-489.63-487.03 489.47 487.36 0 0 1 488.97-487.69 489.47 487.36 0 0 1 489.97 486.7",
    fill: "#fff",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25.046,
    style: {
      fill: "none",
      strokeWidth: 35.064
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.962 -7.2858)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 151.25,
    x2: 151.25,
    y1: 361.13,
    y2: 702.52,
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeWidth: "25.366px",
    style: {
      strokeWidth: 25.046
    },
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.0018
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m397.87 346.23c98.127 0 144.75 53.17 166.6 97.766 23.207 47.442 23.494 94.36 23.494 96.339 0 0.39012 0.38059 43.274 21.062 85.102 26.92 54.416 74.67 82.009 142.02 82.009 89.986 0 163.19-75.044 163.19-167.27q0-2.1028-0.0557-4.1961c-2.1814 90.297-74.521 163.08-163.13 163.08-67.309 0-115.1-27.593-142.02-82.009-20.682-41.866-21.062-84.683-21.062-85.111 0-1.9696-0.25991-48.888-23.494-96.329-21.842-44.597-68.469-97.766-166.6-97.766-50.516 0-98.22 20.381-134.32 57.394-36.1 37.013-55.993 85.901-55.993 137.68 0 1.3987 0 2.7974 0.0557 4.1961 1.0397-50.22 20.812-97.481 55.937-133.49 36.137-36.975 83.804-57.394 134.32-57.394z",
    fill: "#11a2ea",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m883.63 403.15c-36.019-37.084-83.603-57.582-133.99-57.741a194.57 189.52 86.647 0 0-101.67 29.979 13.887 13.527 86.647 0 0 14.454 23.501 166.81 162.49 86.647 0 1 87.177-25.719c88.39 0.27824 160.55 73.192 162.72 163.4q0.0555 2.1006 0.0555 4.1915c0 92.122-73.019 166.85-162.78 166.57-67.14-0.21134-114.82-27.923-141.67-82.361-20.63-41.883-21.01-84.652-21.01-85.07 0-1.9768-0.25926-48.842-23.435-96.302-21.704-44.614-68.214-97.907-166.09-98.215-50.39-0.15862-97.974 20.049-133.98 56.906-35.038 35.853-54.76 82.997-55.797 133.16 1.037 50.165 20.76 97.434 55.797 133.51 36.01 37.074 83.594 57.582 133.98 57.74a194.35 189.31 86.647 0 0 104.11-31.587 13.887 13.527 86.647 1 0-14.815-23.274 166.62 162.3 86.647 0 1-89.297 27.1c-88.39-0.27823-160.55-73.164-162.75-163.36q-0.0556-2.091-0.0556-4.1914c0-92.132 73.029-166.85 162.78-166.57 67.149 0.21137 114.82 27.79 141.59 81.962 20.593 41.626 20.963 84.243 20.963 84.652 0 1.9864 0.27778 49.032 23.463 96.692 21.806 44.814 68.334 98.287 166.22 98.595 50.39 0.15862 97.974-20.049 133.99-56.897 35.038-35.853 54.751-82.997 55.788-133.16-1.037-50.165-20.722-97.443-55.76-133.51z",
    fill: "#212121",
    style: {
      strokeWidth: 8.5156
    },
    className: "cls-3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHndLogo);
export default __webpack_public_path__ + "static/media/HND-logo.86ba74db88b5c85666267284719c8f8d.svg";
export { ForwardRef as ReactComponent };